import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";

const ReceiptPrint = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );

  const orderId = searchParams.get("order_id") || "";

  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchReceipt = async () => {
      try {
        const res = await axios.get(
          "/api/kiosk/receipt_print",
          {
            params: {
              order_id: orderId,
            },
            withCredentials: true,
          }
        );

        setData(res.data || {});
      } catch (err) {
        setErrorMsg(
          err.response?.data?.msg ||
            err.response?.data?.message ||
            "영수증 정보를 불러오지 못했습니다."
        );
      } finally {
        setLoading(false);
      }
    };

    fetchReceipt();
  }, [orderId]);

  const won = (n) =>
    `${Number(n || 0).toLocaleString("ko-KR")}원`;

  if (loading) {
    return (
      <>
        <style>{`
          body {
            font-family: system-ui, -apple-system, "Apple SD Gothic Neo", "Noto Sans KR", sans-serif;
            margin:0;
            background:#f6f7f9;
          }

          .wrap {
            max-width:420px;
            margin:0 auto;
            padding:16px;
          }

          .paper {
            background:#fff;
            border-radius:14px;
            padding:18px;
            box-shadow:0 6px 18px rgba(0,0,0,.06);
          }
        `}</style>

        <div className="wrap">
          <div className="paper">
            영수증 정보를 불러오는 중...
          </div>
        </div>
      </>
    );
  }

  if (errorMsg) {
    return (
      <>
        <style>{`
          body {
            font-family: system-ui, -apple-system, "Apple SD Gothic Neo", "Noto Sans KR", sans-serif;
            margin:0;
            background:#f6f7f9;
          }

          .wrap {
            max-width:420px;
            margin:0 auto;
            padding:16px;
          }

          .paper {
            background:#fff;
            border-radius:14px;
            padding:18px;
            box-shadow:0 6px 18px rgba(0,0,0,.06);
          }

          .actions {
            margin-top:12px;
            display:flex;
            gap:10px;
          }

          .btn {
            flex:1;
            border:1px solid #ddd;
            background:#fff;
            padding:12px 10px;
            border-radius:12px;
            font-weight:700;
          }

          .btn.primary {
            background:#111;
            color:#fff;
            border-color:#111;
          }
        `}</style>

        <div className="wrap">
          <div className="paper">
            <div
              style={{
                color:"#dc3545",
                fontWeight:700,
              }}
            >
              {errorMsg}
            </div>

            <div className="actions">
              <button
                className="btn"
                onClick={() => navigate(-1)}
              >
                닫기
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }

  const order = data?.order || {};
  const items = Array.isArray(data?.items)
    ? data.items
    : [];

  const payAmount = Number(
    data?.pay_amount || 0
  );

  const isKiosk = Boolean(
    data?.is_kiosk
  );

  return (
    <>
      <style>{`
        body {
          font-family: system-ui, -apple-system, "Apple SD Gothic Neo", "Noto Sans KR", sans-serif;
          margin:0;
          background:#f6f7f9;
        }

        .wrap {
          max-width:420px;
          margin:0 auto;
          padding:16px;
        }

        .paper {
          background:#fff;
          border-radius:14px;
          padding:18px;
          box-shadow:0 6px 18px rgba(0,0,0,.06);
        }

        .title {
          font-size:20px;
          font-weight:800;
        }

        .muted {
          color:#666;
          font-size:12px;
        }

        .row {
          display:flex;
          justify-content:space-between;
          gap:12px;
          margin-top:8px;
          font-size:14px;
        }

        .hr {
          height:1px;
          background:#eee;
          margin:14px 0;
        }

        .items {
          margin-top:10px;
        }

        .item {
          display:flex;
          justify-content:space-between;
          gap:10px;
          padding:10px 0;
          border-bottom:1px dashed #e7e7e7;
        }

        .item:last-child {
          border-bottom:0;
        }

        .item .name {
          font-weight:700;
        }

        .item .sub {
          color:#666;
          font-size:12px;
          margin-top:3px;
        }

        .option-line {
          color:#666;
          font-size:12px;
          line-height:1.35;
          margin-top:2px;
        }

        .normal-price {
          color:#999;
          font-size:12px;
          text-decoration:line-through;
          margin-top:3px;
        }

        .sale-price {
          color:#dc3545;
          font-size:12px;
          font-weight:800;
          margin-top:2px;
        }

        .option-total {
          color:#0d6efd;
          font-size:12px;
          margin-top:2px;
        }

        .total {
          font-size:18px;
          font-weight:900;
        }

        .badge {
          display:inline-block;
          font-size:12px;
          padding:6px 10px;
          border-radius:999px;
          background:#111;
          color:#fff;
        }

        .actions {
          margin-top:12px;
          display:flex;
          gap:10px;
        }

        .btn {
          flex:1;
          border:1px solid #ddd;
          background:#fff;
          padding:12px 10px;
          border-radius:12px;
          font-weight:700;
        }

        .btn.primary {
          background:#111;
          color:#fff;
          border-color:#111;
        }

        @media print {
          body {
            background:#fff;
          }

          .wrap {
            max-width:none;
            padding:0;
          }

          .paper {
            box-shadow:none;
            border-radius:0;
            padding:0;
          }

          .actions {
            display:none !important;
          }
        }
      `}</style>

      <div className="wrap">
        <div className="paper">
          <div
            style={{
              display:"flex",
              justifyContent:"space-between",
              alignItems:"flex-start",
              gap:"10px",
            }}
          >
            <div>
              <div className="title">
                영수증
              </div>

              <div className="muted">
                가게: {order.shop_name || ""}
              </div>
            </div>

            <div className="badge">
              {order.status || ""}
            </div>
          </div>

          <div className="hr" />

          <div className="row">
            <div>주문번호</div>
            <div>
              <b>#{Number(order.id || 0)}</b>
            </div>
          </div>

          <div className="row">
            <div>주문일시</div>
            <div>
              {order.order_date || ""}
            </div>
          </div>

          <div className="row">
            <div>결제수단</div>
            <div>
              {order.payment_method || ""}
            </div>
          </div>

          {!isKiosk ? (
            <>
              <div className="row">
                <div>주문자</div>
                <div>
                  {order.buyer_name || ""}
                </div>
              </div>

              <div className="row">
                <div>연락처</div>
                <div>
                  {order.buyer_phone || ""}
                </div>
              </div>
            </>
          ) : null}

          <div className="hr" />

          <div className="items">
            {items.length > 0 ? (
              items.map((it, idx) => {
                const options =
                  Array.isArray(it.options)
                    ? it.options
                    : [];

                const quantity = Number(
                  it.quantity ??
                    it.qty ??
                    0
                );

                const originalPrice = Number(
                  it.original_price ??
                    it.normal_price ??
                    it.price ??
                    0
                );

                const productPrice = Number(
                  it.product_price ??
                    it.display_price ??
                    it.price ??
                    0
                );

                const optionTotal = Number(
                  it.option_total ??
                    it.option_price ??
                    0
                );

                const unitPrice = Number(
                  it.unit_price ??
                    (
                      productPrice +
                      optionTotal
                    )
                );

                const subtotal = Number(
                  it.subtotal ??
                    it.line ??
                    it.line_total ??
                    (
                      unitPrice *
                      quantity
                    )
                );

                const isSale =
                  Boolean(it.is_sale) ||
                  (
                    originalPrice > 0 &&
                    productPrice > 0 &&
                    productPrice <
                      originalPrice
                  );

                return (
                  <div
                    className="item"
                    key={`${
                      it.order_item_id ||
                      it.product_id ||
                      idx
                    }-${idx}`}
                  >
                    <div>
                      <div className="name">
                        {it.name ||
                          it.product_name ||
                          ""}
                      </div>

                      {options.length > 0 ? (
                        <div>
                          {options.map(
                            (opt, optIdx) => {
                              const groupName =
                                opt.option_group_name ||
                                opt.group_name ||
                                "";

                              const itemName =
                                opt.option_item_name ||
                                opt.item_name ||
                                "";

                              const optionPrice =
                                Number(
                                  opt.option_price ??
                                    opt.extra_price ??
                                    0
                                );

                              return (
                                <div
                                  className="option-line"
                                  key={`${
                                    it.order_item_id ||
                                    it.product_id
                                  }-${optIdx}`}
                                >
                                  ·{" "}
                                  {groupName
                                    ? `${groupName}: `
                                    : ""}
                                  {itemName}

                                  {optionPrice !==
                                  0
                                    ? ` (${
                                        optionPrice >
                                        0
                                          ? "+"
                                          : ""
                                      }${won(
                                        optionPrice
                                      )})`
                                    : ""}
                                </div>
                              );
                            }
                          )}
                        </div>
                      ) : null}

                      {isSale ? (
                        <div className="normal-price">
                          정상가{" "}
                          {won(originalPrice)}
                        </div>
                      ) : null}

                      <div
                        className={
                          isSale
                            ? "sale-price"
                            : "sub"
                        }
                      >
                        상품{" "}
                        {won(productPrice)}
                      </div>

                      {optionTotal > 0 ? (
                        <div className="option-total">
                          옵션 +
                          {won(optionTotal)}
                        </div>
                      ) : null}

                      <div className="sub">
                        수량 {quantity}
                        {" · "}
                        단가 {won(unitPrice)}
                      </div>
                    </div>

                    <div
                      style={{
                        fontWeight:800,
                        whiteSpace:"nowrap",
                      }}
                    >
                      {won(subtotal)}
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="muted">
                상품 내역이 없습니다.
              </div>
            )}
          </div>

          <div className="hr" />

          <div className="row total">
            <div>결제금액</div>
            <div>
              {won(payAmount)}
            </div>
          </div>

          <div className="actions">
            <button
              type="button"
              className="btn"
              onClick={() => window.print()}
            >
              인쇄
            </button>

            <button
              type="button"
              className="btn primary"
              onClick={() => navigate(-1)}
            >
              닫기
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReceiptPrint;
